import type { ButtonHTMLAttributes, ReactElement } from 'react';

import { css, styled } from 'styled-components';

export type CircleButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  'data-test-id'?: string;
  icon: ReactElement;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
};

const buttonSizeExtraSmall = css`
  width: 2rem;
  height: 2rem;

  svg {
    width: 75%;
    height: auto;
  }
`;

const buttonSizeSmall = css`
  width: 2.625rem;
  height: 2.625rem;

  svg {
    width: 65%;
    height: auto;
  }
`;

const buttonSizeNormal = css`
  width: 3.25rem;
  height: 3.25rem;

  svg {
    width: 55%;
    height: auto;
  }
`;

const buttonSizeLarge = css`
  width: 3.875rem;
  height: 3.875rem;

  svg {
    width: 45%;
    height: auto;
  }
`;

export const DefaultCircleButtonSC = styled.button<{ $size?: 'xs' | 'sm' | 'md' | 'lg' }>`
  ${(props) => {
    switch (props.$size) {
      case 'xs':
        return buttonSizeExtraSmall;
      case 'sm':
        return buttonSizeSmall;
      case 'lg':
        return buttonSizeLarge;
      default:
        return buttonSizeNormal;
    }
  }}

  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  border: 0;
  outline: 0;
  user-select: none;
  text-decoration: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
  padding: 0;

  &:disabled {
    box-shadow: none;
    cursor: default;
  }
`;

export const CircleButton = ({ icon, size, ...props }: CircleButtonProps) => {
  return (
    <DefaultCircleButtonSC $size={size} {...props}>
      {icon}
    </DefaultCircleButtonSC>
  );
};
